<div class="flex items-start gap-4 mb-6">
  <p-badge [value]="phase()" class="phase-badge" />
  <div>
    <h1 class="text-2xl font-bold m-0">{{ titleKey() | transloco }} - {{ companyName() }}</h1>
    <h2 class="text-xl mb-4">
      {{ 'provider.tenderWizard.subTitle' | transloco }}: {{ projectName() }}
    </h2>
  </div>
</div>
